export const STORE_TYPES = {
  SMALL_RETAIL: 'SMALL_RETAIL',
  SUPERMARKET: 'SUPERMARKET',
  JEWELLERY: 'JEWELLERY',
  BRIDAL_RENTAL: 'BRIDAL_RENTAL',
};

const STORE_TYPE_ALIASES = {
  SMALL_RETAIL: STORE_TYPES.SMALL_RETAIL,
  RETAIL: STORE_TYPES.SMALL_RETAIL,
  SMALL_RETAIL_SHOP: STORE_TYPES.SMALL_RETAIL,
  SUPERMARKET: STORE_TYPES.SUPERMARKET,
  HYPERMARKET: STORE_TYPES.SUPERMARKET,
  JEWELLERY: STORE_TYPES.JEWELLERY,
  JEWELRY: STORE_TYPES.JEWELLERY,
  BRIDAL_RENTAL: STORE_TYPES.BRIDAL_RENTAL,
  RENTAL: STORE_TYPES.BRIDAL_RENTAL,
};

export const normalizeStoreType = (businessType, storeType) => {
  const normalizedStore = (storeType || '').trim().toUpperCase();
  const normalizedBusiness = (businessType || '').trim().toUpperCase();

  if (STORE_TYPE_ALIASES[normalizedStore]) {
    return STORE_TYPE_ALIASES[normalizedStore];
  }

  if (STORE_TYPE_ALIASES[normalizedBusiness]) {
    return STORE_TYPE_ALIASES[normalizedBusiness];
  }

  return STORE_TYPES.SMALL_RETAIL;
};
